import { IsNotEmpty, IsIn, IsOptional } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IElementDeductions } from "./element-deductions.interface";

export class ElementDeductionsDto implements IElementDeductions {
  //
  @IsOptional()
  @IsIn(Object.values(Constants.deductions))
  element_name?: string;

  @IsNotEmpty()
  element_deductions: string;
}
